const Adress = {
    frontendUrl: 'https://jekforms.jeknowledge.com',
  };
  
  export default Adress;